import React from 'react';
import useQueryString from '../../../../hooks/use-query-string';
import OfferableCoupon from '../../OfferableCoupon';
import { useHistory } from 'react-router-dom';

export default function Offer() {
  const history = useHistory();
  const { sch: schoolId, sid: studentId } = useQueryString();

  const handleContinue = () => {
    history.push('/past_images');
  };

  return (
    <div>
      <OfferableCoupon
        onContinue={handleContinue}
        schoolId={schoolId}
        studentId={studentId}
      />
    </div>
  );
}
